import api from '../../api/axios';
import { showError } from '../../Components/reuse/Toast';

export const GET_AGENCY_REFERRED_USERS_REQUEST = 'GET_AGENCY_REFERRED_USERS_REQUEST';
export const GET_AGENCY_REFERRED_USERS_SUCCESS = 'GET_AGENCY_REFERRED_USERS_SUCCESS';
export const GET_AGENCY_REFERRED_USERS_FAILURE = 'GET_AGENCY_REFERRED_USERS_FAILURE';

// Agency Suggested Questions
export const GET_AGENCY_SUGGESTED_QUESTIONS_REQUEST = 'GET_AGENCY_SUGGESTED_QUESTIONS_REQUEST';
export const GET_AGENCY_SUGGESTED_QUESTIONS_SUCCESS = 'GET_AGENCY_SUGGESTED_QUESTIONS_SUCCESS';
export const GET_AGENCY_SUGGESTED_QUESTIONS_FAILURE = 'GET_AGENCY_SUGGESTED_QUESTIONS_FAILURE';


export const getAgencyReferredUsers = ({ startDate, endDate, search, page, limit } = {}) => async (dispatch) => {
    dispatch({ type: GET_AGENCY_REFERRED_USERS_REQUEST });
    try {
        const payload = { startDate, endDate, search, page, limit };
        const response = await api.post('agency/list', payload);

        const success = response?.data?.success === undefined ? true : response.data.success;
        if (success) {
            dispatch({ type: GET_AGENCY_REFERRED_USERS_SUCCESS, payload: response.data });
            return { success: true, data: response.data };
        }

        const message = response?.data?.message || 'Failed to fetch user list data';
        dispatch({ type: GET_AGENCY_REFERRED_USERS_FAILURE, error: message });
        showError(message);
        return { success: false, error: message };
    } catch (error) {
        const message = error?.response?.data?.message || 'Failed to fetch user list data';
        dispatch({ type: GET_AGENCY_REFERRED_USERS_FAILURE, error: message });
        showError(message);
        return { success: false, error: message };
    }
};

// Get suggested questions for Agency (uses agencyId)
export const getAgencySuggestedQuestions = (page = 1, limit = 25, agencyId) => async (dispatch) => {
  dispatch({ type: GET_AGENCY_SUGGESTED_QUESTIONS_REQUEST });
  try {
    const response = await api.post(`agency/referredUsers?page=${page}&limit=${limit}`, {
      agencyId: agencyId || undefined,
    });

    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_AGENCY_SUGGESTED_QUESTIONS_SUCCESS, payload: response.data });
    } else {
      const message = response?.data?.message || 'Failed to fetch suggested questions';
      dispatch({ type: GET_AGENCY_SUGGESTED_QUESTIONS_FAILURE, error: message });
      showError(message);
    }
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch suggested questions';
    dispatch({ type: GET_AGENCY_SUGGESTED_QUESTIONS_FAILURE, error: message });
    showError(message);
  }
};
